//#region import
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Avatar, Box, Card, Divider, Grid, Stack, Typography } from '@mui/material';
import CardFrom from 'components/CardContent/CardFrom';
import { Extension, FnAxios, FnDialog, I18n, ParseHtml } from 'utilities/utilities';

import DefaultAvatar from "assets/images/NoImage/default-avatar.png";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MailIcon from '@mui/icons-material/Mail';
import CallIcon from '@mui/icons-material/Call';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import { ApiLeave } from 'enum/api';
import { APIStatusCode, EnumLeaveTypeID, EnumLogHistoryMode, EnumModeProfiles, EnumSaveModeLeave, I18NextNs } from 'enum/enum';

import AccordionCustom from "components/Accordion";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import DialogPreview from 'components/DialogPreview/DialogPreview';
import LogHistory from './LogHistory';
import Profiles from './Profiles';
import { BtnApprove, BtnBack, BtnRecall, BtnReject, BtnSave } from 'components/Button/ButtonAll';
import { log } from 'console';
import { FormProvider, useForm } from 'react-hook-form';
import UploadFileItem from 'components/Input/UploadFile';
import { TextAreaItem } from 'components/Input/TextArea';
import { useLocation } from 'react-router';
//#endregion

export interface IPropsModalApprover {
    isModalApprover: boolean;
    setisModalApprover: (value: boolean) => void,
    ObjApprover: any;
    setisLoadingTable: (value: boolean) => void,
}

const ModalApprover = (props: IPropsModalApprover) => {
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const location = useLocation();

    const { isModalApprover, ObjApprover, setisModalApprover, setisLoadingTable } = props;
    const [ObjData, setObjData] = useState(null);
    const [arrFile, setarrFile] = useState([]);
    const onClearFile = useRef(null);

    const [isOpenComment, setOpenComment] = useState(false);
    const [nSaveTypeID, setnSaveTypeID] = useState(null);

    // const [sRemark, setsRemark] = useState(null);

    const form = useForm({
        shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
    });

    useEffect(() => {
        if (ObjApprover && ObjApprover?.nLeaveID) GetDataFormApprover();
    }, [ObjApprover]);

    const GetDataFormApprover = () => {
        DialogFn.BlockUI();
        AxiosFn.Get(ApiLeave.GetFormLeaveID, { nLeaveID: ObjApprover.nLeaveID }, (result) => {
            DialogFn.UnBlockUI();
            if (result.nStatusCode === APIStatusCode.Success) {
                setObjData({
                    nLeaveID: result.objResult.nLeaveID,
                    sLeaveType: result.objResult.sLeaveType,
                    sStart_Date: result.objResult.sStart_Date,
                    sEnd_Date: result.objResult.sEnd_Date,
                    sAddress: result.objResult.sAddress,
                    sTelNo: result.objResult.sTelNo,
                    sDescription: result.objResult.sDescription,
                });
                setarrFile([...result.objResult.arrFile]);
            } else {
                DialogFn.Warning(result.sMessage);
            }
        });
    }

    const handleSaveApproveLeave = (nSaveModeLeave) => {
        let objParam = {
            nLeaveID: ObjApprover.nLeaveID,
            nApproveID: ObjApprover.nApproveID,
            nApprovePositionID: ObjApprover.nApprovePositionID,
            nFromStatusID: ObjApprover.nFromStatusID,
            nSaveModeLeave: nSaveModeLeave,
            sRemark: form.getValues("sComment") ?? null,

            sLocation: location.pathname,
        };
        DialogFn.BlockUI();
        AxiosFn.Post(ApiLeave.SaveApproveLeave, objParam, (result) => {
            DialogFn.UnBlockUI();
            if (result.nStatusCode === APIStatusCode.Success) {
                DialogFn.Success(nSaveTypeID === EnumSaveModeLeave.Recall
                    ? I18n.SetText("Message.SaveRecallComplete", I18NextNs.labelComponent)
                    : nSaveTypeID === EnumSaveModeLeave.Reject
                        ? I18n.SetText("Message.SaveRejectComplete", I18NextNs.labelComponent)
                        : I18n.SetText("Message.SaveApproveComplete", I18NextNs.labelComponent), () => { setisModalApprover(false); setisLoadingTable(true); });
            } else {
                DialogFn.Warning(result.sMessage);
            }
        });
    }

    return (
        <Grid item container xs={12} md={12} spacing={2} style={{ paddingBottom: '1%', }}>
            <DialogPreview
                IsOpen={isModalApprover}
                IsBackdropClick={false}
                onClose={() => { setisModalApprover(false); }}
                JsxDialogAction
                CloseSave={false}
                Close={false}
                sMaxWidth='lg'
                bgColor={"#a07300"}
                Color='white'
                Title={'ข้อมูลใบขอลางาน'}
                // fullScreen={true}
                isDialogTitle={true}
            >
                <Grid item xs={12} md={12} container spacing={2} justifyItems={'flex-start'} justifyContent={'flex-start'} style={{ padding: '2%', }}>
                    <Grid item xs={12} md={12} style={{ paddingBottom: '1%', }}>
                        <Profiles nUserID={ObjApprover.nUserID} nYear={ObjApprover.nYear} nMode={EnumModeProfiles.Leave} />
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={2} justifyItems={'center'} justifyContent={'center'} style={{ paddingBottom: '1%', }}>
                        <Grid item xs={12} md={11.5} container spacing={1.5}>
                            <Grid item xs={12} md={12} container spacing={1}>
                                <Grid item xs={12} md={3} style={{ backgroundColor: "#e7f5ff" }}><Typography gutterBottom variant="body1" fontWeight="bold">{`${I18n.SetText("Leave.sLeaveType")}`}</Typography></Grid>
                                <Grid item xs={12} md={9} style={{ backgroundColor: "rgb(249 249 249)" }}><Typography gutterBottom variant="body1">{ObjData?.sLeaveType}</Typography></Grid>
                            </Grid>
                            <Grid item xs={12} md={12} container spacing={1}>
                                <Grid item xs={12} md={3} style={{ backgroundColor: "#e7f5ff" }}><Typography gutterBottom variant="body1" fontWeight="bold">{`${I18n.SetText("Leave.sLeaveStartDate")}`}</Typography></Grid>
                                <Grid item xs={12} md={9} style={{ backgroundColor: "rgb(249 249 249)" }}><Typography gutterBottom variant="body1">{ObjData?.sStart_Date}</Typography></Grid>
                            </Grid>
                            <Grid item xs={12} md={12} container spacing={1}>
                                <Grid item xs={12} md={3} style={{ backgroundColor: "#e7f5ff" }}><Typography gutterBottom variant="body1" fontWeight="bold">{`${I18n.SetText("Leave.sLeaveEndDate")}`}</Typography></Grid>
                                <Grid item xs={12} md={9} style={{ backgroundColor: "rgb(249 249 249)" }}><Typography gutterBottom variant="body1">{ObjData?.sEnd_Date}</Typography></Grid>
                            </Grid>
                            <Grid item xs={12} md={12} container spacing={1}>
                                <Grid item xs={12} md={3} style={{ backgroundColor: "#e7f5ff" }}><Typography gutterBottom variant="body1" fontWeight="bold">{`${I18n.SetText("Leave.sDuringLeaveContactAt")}`}</Typography></Grid>
                                <Grid item xs={12} md={9} style={{ backgroundColor: "rgb(249 249 249)" }}><Typography gutterBottom variant="body1">{ParseHtml(ObjData?.sAddress)}</Typography></Grid>
                            </Grid>
                            <Grid item xs={12} md={12} container spacing={1}>
                                <Grid item xs={12} md={3} style={{ backgroundColor: "#e7f5ff" }}><Typography gutterBottom variant="body1" fontWeight="bold">{`${I18n.SetText("Leave.sTelNo")}`}</Typography></Grid>
                                <Grid item xs={12} md={9} style={{ backgroundColor: "rgb(249 249 249)" }}><Typography gutterBottom variant="body1">{ObjData?.sTelNo}</Typography></Grid>
                            </Grid>
                            <Grid item xs={12} md={12} container spacing={1}>
                                <Grid item xs={12} md={3} style={{ backgroundColor: "#e7f5ff" }}><Typography gutterBottom variant="body1" fontWeight="bold">{`${I18n.SetText("Leave.sReasonForLeave")}`}</Typography></Grid>
                                <Grid item xs={12} md={9} style={{ backgroundColor: "rgb(249 249 249)" }}><Typography gutterBottom variant="body1">{ParseHtml(ObjData?.sDescription)}</Typography></Grid>
                            </Grid>
                            <Grid item xs={12} md={12} container spacing={1}>
                                <Grid item xs={12} md={3} style={{ backgroundColor: "#e7f5ff" }}><Typography gutterBottom variant="body1" fontWeight="bold">{`${I18n.SetText("Leave.sEvidenceDocuments")}`}</Typography></Grid>
                                <Grid item xs={12} md={9} style={{ backgroundColor: (arrFile.length === 0 ? "rgb(249 249 249)" : "") }}>
                                    <FormProvider {...form}>
                                        <UploadFileItem
                                            required={false}
                                            modeDisplay={"list"}
                                            id={"oFileDocument"}
                                            name={"oFileDocument"}
                                            key={1}
                                            IsDrag={false}
                                            arrFile={arrFile}
                                            setarrFile={setarrFile}
                                            Extension={[...Extension.PDF, Extension.Image_New, Extension.Word, Extension.Other]}
                                            IsFolder={false}
                                            isFileChange={true}
                                            IsMultiple={true}
                                            onClearFile={onClearFile}
                                            sFolderTemp="Leave"
                                            nLimitFile={30}
                                            sLimitFile="MB"
                                            sPositionText="right"
                                            IsMultiDelete={false}
                                            disabled={true}
                                            IsHide={true}
                                        />
                                    </FormProvider>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={1} justifyContent="center" style={{ paddingBottom: '2%', }}>
                        <Grid item>
                            <BtnBack id={"btnBack"} onClick={() => setisModalApprover(false)} />
                        </Grid>
                        <Grid item>
                            {/* <BtnRecall id={"btnRecall"} txt={I18n.SetText("Button.SendEdit", I18NextNs.labelComponent)} onClick={(e) => handleSaveApproveLeave(EnumSaveModeLeave.Recall)} /> */}
                            <BtnRecall id={"btnRecall"} txt={I18n.SetText("Button.SendEdit", I18NextNs.labelComponent)} onClick={(e) => { setnSaveTypeID(EnumSaveModeLeave.Recall); setOpenComment(true); }} />
                        </Grid>
                        <Grid item>
                            {/* <BtnReject id={"btnReject"} txt={I18n.SetText("Button.RejectReques", I18NextNs.labelComponent)} onClick={(e) => handleSaveApproveLeave(EnumSaveModeLeave.Reject)} /> */}
                            <BtnReject id={"btnReject"} txt={I18n.SetText("Button.RejectReques", I18NextNs.labelComponent)} onClick={(e) => { setnSaveTypeID(EnumSaveModeLeave.Reject); setOpenComment(true); }} />
                        </Grid>
                        <Grid item>
                            <BtnApprove id={"btnApprove"} onClick={(e) => {
                                DialogFn.Submit(I18n.SetText("Message.ConfirmApprove", I18NextNs.labelComponent), () => {
                                    handleSaveApproveLeave(EnumSaveModeLeave.Approve);
                                });
                            }} />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <LogHistory nRefID={ObjApprover.nLeaveID} nMode={EnumLogHistoryMode.Leave} />
                    </Grid>
                </Grid>
            </DialogPreview>

            <DialogPreview
                IsOpen={isOpenComment}
                Title={nSaveTypeID === EnumSaveModeLeave.Recall ? `${I18n.SetText("Leave.sRemarkRecall")}` : `${I18n.SetText("Leave.sRemarkReject")}`}
                onClose={() => { setOpenComment(false); form.reset(); setnSaveTypeID(null); }}
                sMaxWidth='xs'
                CloseSave={true}
            >
                <FormProvider {...form}>
                    <TextAreaItem
                        label={""}
                        id={`sComment`}
                        name={`sComment`}
                        row={4}
                        required={isOpenComment}
                        maxLength={500}
                    />
                    <Stack direction={"row"} justifyContent={"end"} sx={{ width: "100%", mt: 2, mb: 1 }}>
                        <BtnSave id={"btnSave"} onClick={form.handleSubmit(e => { handleSaveApproveLeave(nSaveTypeID) })} />
                    </Stack>
                </FormProvider>
            </DialogPreview>
        </Grid>
    )
}
export default ModalApprover;
